/* ======================================================
   DRIVER TYPES
====================================================== */

export const DRIVER_TYPES = [

  {
    value: "employee",
    label: "Empleado"
  },

  {
    value: "freelancer",
    label: "Freelancer"
  }

];